// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    filterdata:null,
    filterdatamodal:null,
  },
  reducers: {
    filterData: (state, action) => {
      state.filterdata = action.payload;
    },
    filterDataModal: (state, action) => {
      state.filterdatamodal = action.payload;
    }, 
    clearFilterData: (state) => {
      state.filterdata = null;
    },
    clearFilterDataModal: (state) => {
      state.filterdatamodal = null;
    },
  },
});

export const { filterData,filterDataModal, clearFilterData, clearFilterDataModal} = filterSlice.actions;
export const selectFilterdata = (state) => state.filter.filterdata;
export const selectFilterdataModal = (state) => state.filter.filterdatamodal;


export default filterSlice.reducer;


